import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent {
  @Input() title: string = 'Modal Title';
  @Input() isOpen: boolean = false;
  @Input() dateCreated: string = '';
  @Input() dateUpdated: string = ''
  @Output() closeModalEvent = new EventEmitter<void>();

  closeModal() {
    this.closeModalEvent.emit();
  }
  formatDate(date: string){
    const dateTimeString = date;
    const dateTime = new Date(dateTimeString);
     return dateTime.toLocaleString();
   }
  

  stopPropagation(event: Event) {
    event.stopPropagation();
  }
}
